export default __webpack_public_path__ + "static/media/cashbox.3db53e88.png";